module.exports = __webpack_public_path__ + "static/img_4263-7944f848d9d797d356698a00daa456bb.webp";